import * as React from 'react'
import { MarketingLayout } from '../components/marketing-layout'
import { MarketingPageContainer, PageTitle, PageSubtitle, MarketingSection } from '../styles/marketing.styles'

export const AboutPage: React.FC = () => (
  <MarketingLayout>
    <MarketingPageContainer>
      <MarketingSection>
        <PageTitle>About Equa</PageTitle>
        <PageSubtitle>Cap table and equity management made simple.</PageSubtitle>
        <p>Equa helps companies and funds manage cap tables, ESOPs, convertibles, and documents in one place. Our mission is to make equity transparent and accessible.</p>
      </MarketingSection>
      <MarketingSection>
        <h2>Our story</h2>
        <p>
          Equa was founded on the belief that equity management should be simple, transparent, and
          accessible to every company — not just large enterprises. We built Equa to give founders,
          legal teams, and investors a single source of truth for cap tables, ESOP plans, and
          convertible instruments.
        </p>
      </MarketingSection>
      <MarketingSection>
        <h2>Values</h2>
        <p><strong>Transparency.</strong> Every stakeholder deserves to understand their ownership and how decisions affect it.</p>
        <p><strong>Simplicity.</strong> Complex equity structures should be manageable without a law degree.</p>
        <p><strong>Trust.</strong> We treat your cap table data with the same care you'd expect from your legal counsel.</p>
      </MarketingSection>
    </MarketingPageContainer>
  </MarketingLayout>
)
